import { BlockCodeMirrorField } from '../CodeMirror/CodeMirror';

interface SharedFunctionBlockFormFieldsProps {
  fieldNamePrefix?: string;
}

export function SharedFunctionBlockFormFields(props: SharedFunctionBlockFormFieldsProps) {
  const { fieldNamePrefix = 'config' } = props;
  return (
    <BlockCodeMirrorField
      label="Script"
      autoFocus
      fieldName={`${fieldNamePrefix}.fn`}
      helperText="Write the script as if you're coding the body of a function. Use the return statement to define the output, which will be made available in the flow context. The code is executed in an isolated and restricted environment."
    />
  );
}
